import { ActivityType, ActivityTypes, externalActivityParticipant, InternalActivityParticipant } from "../../../DTOs";
import { basicValidation } from "../basicValidation";

export const activityFieldValidation = {
    activity: {
        id: (value: string) => basicValidation.resourceId.isValid(value),
        title: (value: string) => basicValidation.resourceText.isValid(value, false, 100),
        start: basicValidation.date,
        end: basicValidation.date,
        location: (value: string) => basicValidation.resourceText.isValid(value, true, 200),
        description: (value: string) => basicValidation.resourceText.isValid(value, true, 10000),
        type: (value: ActivityType) =>
        {
            return ActivityTypes.find(at => at === value) !== undefined;
        },
        workgroupIdOrNone: (value: string) => basicValidation.resourceId.isValidOrEmpty(value),
        ownerIdOrNone: (value: string) => basicValidation.resourceId.isValidOrEmpty(value),
    },

    activityParticipant: {
        participantId: (value: string) => basicValidation.resourceId.isValid(value),
        object: (value: InternalActivityParticipant | externalActivityParticipant) =>
        {
            if (value === null || value === undefined || typeof value !== 'object') return false;
            if (value.type === 'internal')
                return activityFieldValidation.internalActivityParticipant.participantId(value.id)
                    && activityFieldValidation.internalActivityParticipant.userId(value.userId);
            if (value.type === 'external')
            {
                return activityFieldValidation.externalActivityParticipant.participantId(value.id)
                    && activityFieldValidation.externalActivityParticipant.name(value.name)
                    && activityFieldValidation.externalActivityParticipant.role(value.role)
                    && activityFieldValidation.externalActivityParticipant.email(value.email);
            }
            return false;
        }
    },

    internalActivityParticipant: {
        participantId: (value: string) => basicValidation.resourceId.isValid(value),
        userId: (value: string) => basicValidation.resourceId.isValid(value)
    },

    externalActivityParticipant: {
        participantId: (value: string) => basicValidation.resourceId.isValid(value),
        name: (value: string) => basicValidation.resourceText.isValid(value, false, 100),
        role: (value: string) => basicValidation.resourceText.isValid(value, false, 100),
        email: (value: string) => basicValidation.isValidEmail(value, false),
    },

    agendaItem: {
        id: (value: string) => basicValidation.resourceId.isValid(value),
        title: (value: string) => basicValidation.resourceText.isValid(value, false, 100),
        description: (value: string) => basicValidation.resourceText.isValid(value, true, 10000),
        move: (value: 'up' | 'down' | 'in' | 'out') =>
        {
            if (!value)
                return false;
            return ['up', 'down', 'in', 'out'].find(v => v === value) !== undefined;
        },
        note: (value: string) => basicValidation.resourceText.isValid(value, true, 10000)
    },
};
